// components/AdvancedBreadcrumb.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ userType, currentPath, menuConfig }) => {
  const getBreadcrumbItems = () => {
    const items = [];
    const userMenu = menuConfig[userType];

    if (!userMenu) return items;

    // خانه اول - پنل کاربری
    items.push({
      label: `${userMenu.title} ${getUserTypeLabel(userType)}`,
      link: `/${userType}-panel`,
      isActive: false
    });

    // تابع بازگشتی برای جستجو در منوها
    const findInMenu = (menuItems, path, parentLabel = null) => {
      for (const item of menuItems) {
        // اگر آیتم جاری مطابقت داشته باشد
        if (item.link && path.startsWith(item.link)) {
          if (parentLabel) {
            items.push({
              label: parentLabel,
              link: '#',
              isActive: false
            });
          }
          items.push({
            label: item.label,
            link: item.link,
            isActive: path === item.link
          });
          return true;
        }

        // جستجو در زیرمنوها
        if (item.submenu) {
          for (const subItem of item.submenu) {
            if (subItem.link && path.startsWith(subItem.link)) {
              items.push({
                label: item.label,
                link: item.link || '#',
                isActive: false
              });
              items.push({
                label: subItem.label,
                link: subItem.link,
                isActive: path === subItem.link
              });
              return true;
            }
          }
        }
      }
      return false;
    };

    findInMenu(userMenu.items, currentPath);

    // اگر مسیر پیدا نشد
    if (items.length === 1) {
      // استخراج عنوان از مسیر
      const pathParts = currentPath.split('/').filter(part => part);
      const lastPart = pathParts[pathParts.length - 1];
      if (lastPart && lastPart !== `${userType}-panel`) {
        items.push({
          label: formatLabel(lastPart),
          link: currentPath,
          isActive: true
        });
      } else {
        items[0].isActive = true;
      }
    }

    return items;
  };

  // helper functions
  const getUserTypeLabel = (type) => {
    const labels = {
      customer: 'مشتری',
      supplier: 'تأمین کننده',
      carrier: 'شرکت حمل',
      driver: 'راننده',
      admin: 'کارمند'
    };
    return labels[type] || type;
  };

  const formatLabel = (path) => {
    // تبدیل مسیر به عنوان خوانا
    return path.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  const breadcrumbItems = getBreadcrumbItems();

  if (breadcrumbItems.length === 0) return null;

  return (
    <nav className="mb-6 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <ol className="flex items-center space-x-2 space-x-reverse text-sm">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <svg
                className="w-4 h-4 mx-2 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            )}

            {item.isActive ? (
              <span className="font-medium text-blue-600">
                {item.label}
              </span>
            ) : (
              <Link
                to={item.link}
                className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;